import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/lib/withStyles'

import s from './PopUpNotification.css'

class PopUpNotification extends Component {

  componentDidMount() {
    // this.handleTimeout()
  }

  handleClick = (e, videoId) => {
    const { handleClickNotif } = this.props
    if (handleClickNotif) {
      handleClickNotif(e, videoId)
    }
  }

  handleClickNotifMobile = () => {
    const { handleClickNotifMobile } = this.props
    if (handleClickNotifMobile) {
      handleClickNotifMobile()
    }
  }

  render() {
    const { isMobile, title, desc, enterText, closeText, videoId } = this.props
    return (
      <>
        {!isMobile &&
          <div className={`${s.container}`}>
            <div className={s.icon}> <span><i /></span></div>
            <div className={s.content}>
              <div> {title}</div>
              <div className={s.desc}>{desc}</div>
              {/* {notification.notifText} */}
            </div>
            <div className={s.action}>
              <div className={s.action_wrapper}>
                <a onClick={e => this.handleClick(e, videoId)}>
                  {enterText}
                </a>
                <a className={s.close} onClick={e => this.handleClick(e)}>
                  {closeText}
                </a>
              </div>
            </div>
            {/* <i onClick={e => this.handleCloseNotif(e)} /> */}
          </div>}
        {isMobile &&
          <>
            <div className={s.offset_mobile}></div>
            <div className={`${s.container_mobile} notif-container`}>
              <a onClick={() => this.handleClickNotifMobile()}>
                <span>{notification.notifText}</span>
              </a>
              <i onClick={() => this.handleClickNotifMobile()} />
            </div>
          </>}
      </>
    )
  }
}

export default withStyles(s)(PopUpNotification)
